<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <h3 class="headline mb-0">{{ header }}</h3>
      </div>
    </v-card-title>
    <v-card-text>
      <v-form v-model="validForm">
        <v-container grid-list-md>
          <v-layout justify-center wrap>
            <v-flex xs12>
              <v-text-field
                id="company"
                name="company"
                label="Institution (Tanzschule, Club, etc.)"
                v-model="user.company"
                @keyup.enter="submit"
                :disabled="loading"
                autofocus
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md2>
              <v-select
                :label="$t('gender_select') + '*'"
                :items="[
                  { key: 'male', value: 'Herr' },
                  { key: 'female', value: 'Frau' },
                  { key: 'non_binary', value: 'Divers' }
                ]"
                v-model="user.gender"
                :error="user.gender === 'unknown'"
                @keyup.enter="submit"
                :disabled="loading"
                item-value="key"
                item-text="value"
                required
                :rules="rules.gender"
              >
              </v-select>
            </v-flex>

            <v-flex xs12 sm6 md5>
              <v-text-field
                id="first_name"
                name="first_name"
                label="Vorname*"
                v-model="user.first_name"
                @keyup.enter="submit"
                :disabled="loading"
                :rules="rules.firstName"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md5>
              <v-text-field
                id="last_name"
                name="last_name"
                label="Nachname*"
                v-model="user.last_name"
                :disabled="loading"
                @keyup.enter="submit"
                :rules="rules.lastName"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-text-field
                id="email"
                name="email"
                label="E-Mail Adresse*"
                v-model="user.email"
                :disabled="loading"
                @keyup.enter="submit"
                :rules="rules.email"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs9 md10>
              <v-text-field
                id="street"
                name="street"
                label="Straße*"
                v-model="user.street"
                :disabled="loading"
                @keyup.enter="submit"
                required
                :rules="rules.street"
              ></v-text-field>
            </v-flex>

            <v-flex xs3 md2>
              <v-text-field
                id="street_number"
                name="street_number"
                label="Hausnummer*"
                v-model="user.street_number"
                :disabled="loading"
                @keyup.enter="submit"
                required
                :rules="rules.street_number"
              ></v-text-field>
            </v-flex>

            <v-flex xs3 md2>
              <v-text-field
                id="postcode"
                name="postcode"
                label="PLZ*"
                v-model="user.postcode"
                mask="#####"
                :disabled="loading"
                @keyup.enter="submit"
                required
                :rules="rules.postcode"
              ></v-text-field>
            </v-flex>

            <v-flex xs9 md10>
              <v-text-field
                id="town"
                name="town"
                label="Stadt*"
                v-model="user.town"
                :disabled="loading"
                @keyup.enter="submit"
                required
                :rules="rules.town"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 class="pt-0 pb-0">
              <v-checkbox
                v-model="sameAddressForInvoice"
                :label="$t('forms.same_address_for_invoice')"
                class="mt-0"
              ></v-checkbox>
            </v-flex>

            <v-expand-transition>
              <v-flex xs12 v-if="!sameAddressForInvoice">
                <v-card>
                  <v-card-title>
                    <span class="grey--text">Rechnungsadresse</span>
                  </v-card-title>

                  <v-container class="pt-0">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          id="invoice_company"
                          name="invoice_company"
                          label="Institution (Tanzschule, Club, etc.)"
                          v-model="user.invoice_company"
                          @keyup.enter="submit"
                          :disabled="loading"
                          autofocus
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 md2>
                        <v-select
                          :label="$t('gender_select') + '*'"
                          :items="[
                            { key: 'male', value: 'Herr' },
                            { key: 'female', value: 'Frau' },
                            { key: 'non_binary', value: 'Divers' }
                          ]"
                          v-model="user.invoice_gender"
                          :error="user.invoice_gender === null"
                          @keyup.enter="submit"
                          :disabled="loading"
                          item-value="key"
                          item-text="value"
                          required
                          :rules="rules.gender"
                        >
                        </v-select>
                      </v-flex>

                      <v-flex xs12 sm6 md5>
                        <v-text-field
                          id="invoice_first_name"
                          name="invoice_first_name"
                          label="Vorname*"
                          v-model="user.invoice_first_name"
                          @keyup.enter="submit"
                          :disabled="loading"
                          :rules="rules.firstName"
                          required
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6 md5>
                        <v-text-field
                          id="invoice_last_name"
                          name="invoice_last_name"
                          label="Nachname*"
                          v-model="user.invoice_last_name"
                          :disabled="loading"
                          @keyup.enter="submit"
                          :rules="rules.lastName"
                          required
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs9 md10>
                        <v-text-field
                          id="invoice_street"
                          name="invoice_street"
                          label="Straße*"
                          v-model="user.invoice_street"
                          :disabled="loading"
                          @keyup.enter="submit"
                          required
                          :rules="rules.street"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs3 md2>
                        <v-text-field
                          id="invoice_street_number"
                          name="invoice_street_number"
                          label="Hausnummer*"
                          v-model="user.invoice_street_number"
                          :disabled="loading"
                          @keyup.enter="submit"
                          required
                          :rules="rules.street_number"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs3 md2>
                        <v-text-field
                          id="invoice_postcode"
                          name="invoice_postcode"
                          label="PLZ*"
                          v-model="user.invoice_postcode"
                          mask="#####"
                          :disabled="loading"
                          @keyup.enter="submit"
                          required
                          :rules="rules.postcode"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs9 md10>
                        <v-text-field
                          id="invoice_town"
                          name="invoice_town"
                          label="Stadt*"
                          v-model="user.invoice_town"
                          :disabled="loading"
                          @keyup.enter="submit"
                          required
                          :rules="rules.town"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-expand-transition>

            <v-flex xs12>
              <date-picker
                :error="birthDateError"
                :value.sync="user.birthday"
                :birth-date="true"
                :disabled="loading"
                :error-messages="errorMessages"
                :label="$t('birth_date_entry') + '*'"
                :rules="rules.birthday"
                :max="maxBirthDate"
                @keyup.enter="submit"
                required
              ></date-picker>
            </v-flex>

            <v-flex xs12>
              <v-text-field
                id="telephone"
                name="telephone"
                label="Telefon*"
                v-model="user.telephone"
                :disabled="loading"
                :rules="rules.telephone"
                @keyup.enter="submit"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 v-if="!$hasRole('admin') && (!user.id || !user.valid)">
              <accept-conditions
                :value.sync="conditions"
                required
              ></accept-conditions>
            </v-flex>

            <v-btn
              block
              @click="submit"
              :loading="loading"
              :disabled="!valid"
              >{{ $t(isNewUser ? "register" : "save") }}</v-btn
            >
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import AcceptConditionsComponent from "./common/AcceptConditions";
import DatePicker from "./common/DatePicker";
import { mapMutations } from "vuex";

export default {
  components: {
    "accept-conditions": AcceptConditionsComponent,
    "date-picker": DatePicker
  },
  data() {
    return {
      validForm: false,
      loading: false,
      conditions: false,
      birthDateError: false,
      errorMessages: [],
      maxBirthDate: moment().format("YYYY-MM-DD"),
      sameAddressForInvoice: false,
      user: {
        id: null,
        company: null,
        gender: null,
        first_name: null,
        last_name: null,
        birthday: null,
        email: null,
        street: null,
        street_number: null,
        postcode: null,
        town: null,
        telephone: null,
        invoice_company: null,
        invoice_gender: null,
        invoice_first_name: null,
        invoice_last_name: null,
        invoice_street: null,
        invoice_street_number: null,
        invoice_postcode: null,
        invoice_town: null
      },
      rules: {
        gender: [
          v => !!v || "Anrede fehlt",
          v => ["male", "female", "non_binary"].includes(v) || "Anrede fehlt"
        ],
        firstName: [v => !!v || "Vorname fehlt"],
        lastName: [v => !!v || "Nachname fehlt"],
        street: [v => !!v || "Straße fehlt"],
        street_number: [v => !!v || "Hausnummer fehlt"],
        postcode: [v => !!v || "PLZ fehlt"],
        town: [v => !!v || "Stadt fehlt"],
        telephone: [v => !!v || "Telefonnummer fehlt"],
        birthday: [
          v => !!v || this.$t("forms.missing_birthday")
          //(v) => (this.user.birthday === null || (this.user.birthday !== null && moment().diff(moment(this.user.birthday), 'years') >= 18)) || 'Sie müssen mindestens 18 Jahre alt sein'
        ],
        email: [
          v => !!v || "E-Mail Adresse fehlt",
          v =>
            /^\w+([\.-]?[\w+]+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(v) ||
            "Ungültige E-Mail"
        ]
      }
    };
  },
  computed: {
    isNewUser() {
      return this.user.id === null;
    },
    valid() {
      if ((!this.user.id || !this.user.valid) && !this.conditions) {
        return false;
      }

      return !this.loading && this.validForm && this.errorMessages.length === 0;
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        if (
          this.user.birthday !== null &&
          moment().diff(moment(this.user.birthday), "years") < 0
        ) {
          this.$set(this, "errorMessages", [
            "Das Geburtsdatum muss ind er Vergangenheit liegen"
          ]);
        } else {
          this.$set(this, "errorMessages", []);
        }

        this.birthDateError =
          this.user.birthday === null || this.user.birthday === "";
      }
    },
    sameAddressForInvoice() {
      if (this.sameAddressForInvoice) {
        _.each(this.user, (value, key) => {
          if (key.startsWith("invoice_")) {
            this.user[key] = null;
          }
        });

        this.user.invoice_gender = "";
      }
    }
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    header: {
      type: String,
      default: ""
    }
  },
  mounted() {
    if (this.$hasRole("admin")) {
      this.conditions = true;
    }

    if (this.value) {
      this.$set(this, "user", _.cloneDeep(this.value));
    }

    if (
      !this.user.invoice_company &&
      !this.user.invoice_gender &&
      !this.user.invoice_first_name &&
      !this.user.invoice_last_name &&
      !this.user.invoice_street &&
      !this.user.invoice_street_number &&
      !this.user.invoice_postcode &&
      !this.user.invoice_town
    ) {
      this.sameAddressForInvoice = true;
    } else if (
      this.user.invoice_company === this.user.company &&
      this.user.invoice_gender === this.user.gender &&
      this.user.invoice_first_name === this.user.first_name &&
      this.user.invoice_last_name === this.user.last_name &&
      this.user.invoice_street === this.user.street &&
      this.user.invoice_street_number === this.user.street_number &&
      this.user.invoice_postcode === this.user.postcode &&
      this.user.invoice_town === this.user.town
    ) {
      this.sameAddressForInvoice = true;
    }
  },
  methods: {
    submit() {
      if (!this.valid) {
        return;
      }

      if (this.sameAddressForInvoice) {
        this.user.invoice_company = this.user.company;
        this.user.invoice_gender = this.user.gender;
        this.user.invoice_first_name = this.user.first_name;
        this.user.invoice_last_name = this.user.last_name;
        this.user.invoice_street = this.user.street;
        this.user.invoice_street_number = this.user.street_number;
        this.user.invoice_postcode = this.user.postcode;
        this.user.invoice_town = this.user.town;
      }

      this.loading = true;

      axios.post("/api/v1/users", this.user).then(
        response => {
          if (!response.data.success) {
            this.loading = false;
            this.$emit("error", response.data.message);
            return;
          }

          this.updateUser(response.data.data);

          this.$emit("submit");

          this.loading = false;
        },
        errorResponse => {
          this.loading = false;
          this.$emit("error");
        }
      );
    },
    ...mapMutations(["updateUser"])
  }
};
</script>
